// schemas/userSigninVerifyOtpSchema.ts

import { z } from 'zod';

export const userSigninVerifyOtpSchema = z.object({
  otpCode: z
    .string()
    .trim()
    .length(6, 'Enter the 6-digit OTP'),
});

export type UserSigninVerifyOtpFormValues =
  z.infer<typeof userSigninVerifyOtpSchema>;